import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import L from '../common/localized';

const UITagLine = (props) => (
  <UITagLineElement background={props.background} textColor={props.textColor}>
    <L text={props.children} />
  </UITagLineElement>);

if (process.env.NODE_ENV !== 'production') {
  UITagLine.propTypes = {
    background: PropTypes.string,
    textColor: PropTypes.string
  };
}

UITagLine.defaultProps = {
  background: 'none',
  textColor: '#131313'
};

const UITagLineElement = styled.p`
  display: inline-block;
  background: ${props => props.background};
  color: ${props => props.textColor};
  padding: 0 4px;
  margin-bottom: 8px;
  font-size: 0.85em;
  @media screen and (min-width: 768px) { font-size: 1em; }
  @media screen and (min-width: 992px) { font-size: 1.1em; }
  @media screen and (min-width: 1200px) { font-size: 1.2em; }
`;

export default UITagLine;
